import {useEffect, useState} from "react";
import { Box, Grid } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { t } from "i18next";
import api from "../../../../../helpers/api/Api";
import ApiUrls from "../../../../../helpers/urls/ApiUrls";
import AppConfig from "../../../../../helpers/constants/AppConfig";
import { showStatus } from "../../../../../helpers/api/errors/ShowStatus";
import CustomModal from "../../../../../components/Modal";
import LoadingProgress from "../../../../../components/LoadingProgress";
import InputPlus from "../../../../../components/InputPlus";

function NoCacheDomains({ domain, setOpen }) {
  const [domains, setDomains] = useState([""]);
  const [loading, setLoading] = useState(false);
  const [loadingGet, setLoadingGet] = useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (domain) {
      getByPasses();
    }
  }, [domain]);

  const getByPasses = () => {
    const fd = new FormData();
    fd.append("did", domain.id);

    api.post(ApiUrls.domain.getBypass, fd)
       .then((response) => {
         setLoadingGet(false);
         const domData = response.data?.data?.length === 0 ? [""] : response.data?.data;
         setDomains(domData);
       })
       .catch((error) => {
         setLoadingGet(false);
       });
  }

  const onConfirm = () => {
    setLoading(true);

    const fd = new FormData();
    fd.append("did", domain.id);
    fd.append("bypass", JSON.stringify(domains));

    const snackArgs = {
      item: t("domain.addresses"),
      op: t("global.register")
    };

    api.post(ApiUrls.domain.setBypass, fd)
       .then((response) => {
         setLoading(false);
         showStatus(response.data.status, snackArgs);
         if (response.data.status === "success") {
           setOpen(false);
         }
       })
       .catch((error) => {
         setLoading(false);
         showStatus("error", snackArgs);
       });
  }

  return (
     <CustomModal
        open={true}
        handleClose={handleClose}
        title={"آدرس‌هایی که نمی‌خواهید کش بشوند را در زیر وارد نمایید:"}
     >
       <Box py={2} px={{ md: 5, xs: 0 }}>
         {loadingGet ?
            <LoadingProgress color="info" />
            :
            <>
              <Grid container spacing={2} rowSpacing={3} sx={{ mt: 1 }}
                    className="flex-column-md" justifyContent="center"
              >
                <InputPlus
                   items={domains}
                   label={t("domain.address")}
                   classes={"ltr-textfield"}
                   handleChange={(e) => setDomains(e)}
                   grid_md={7}
                />
              </Grid>

              <Grid container justifyContent="center" mt={4}>
                <Grid item md={4}>
                  <LoadingButton
                     color={AppConfig.color}
                     loading={loading}
                     variant="outlined"
                     fullWidth
                     onClick={onConfirm}
                  >
                    {t("global.register")}
                  </LoadingButton>
                </Grid>
              </Grid>
            </>
         }

       </Box>
     </CustomModal>
  )
}

export default NoCacheDomains;
